<template>
  <div class="container">
    <head-nav-bar
      title="体检开单"
      :fixed="true"
    />
    <div
      class="mt-header-nav"
      style="paddingTop:1px"
    >
      <DataList
        api="Contact_List"
        :onLoadCallBack="onLoad"
      >
        <template
          v-slot:item="item"
          style="padding:10px"
        >
          <div class="contactItem">
            <div class="CardholderName">
              {{ item.obj.cardholderName }}
            </div>
            <div class="CardNo">就诊卡号：{{ item.obj.cardNo }}</div>
            <van-button
              @click="chooseBtn(item.obj)"
              type="info"
              size="small"
              class="chooseBtn"
            >选择此卡</van-button>
          </div>
        </template>
      </DataList>
      <div
        @click="toAddCard"
        v-if="!concactLength"
        class="register"
      >
        没有健康卡，注册申领
      </div>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import { Button, Dialog } from "vant";

export default {
  components: {
    DataList,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      info: {},
      concactLength: 0
    };
  },
  created () { },
  methods: {
    chooseBtn (item) {
      this.$router.push({
        name: "physicalExamBill",
        query: {
          ...item
        }
      });
    },
    onLoad (res) {
      this.concactLength = res.data.datas.length;
    },
    toAddCard () {
      this.$router.push({
        name: "userContactAddCard",
        query: {
          fromPathName: "physicalExamCheck"
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.contactItem {
  margin: 10px;
  border: 1px solid rgb(223, 224, 226);
  background-color: rgb(248, 248, 248);
  padding: 10px;
  position: relative;
  .CardholderName {
    font-weight: bold;
    font-size: 14px;
  }
  .CardNo {
    margin-top: 5px;
    font-weight: bold;
    font-size: 12px;
  }
  .chooseBtn {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}
.ModalHtml {
  padding: 20px 20px 0;
}
.ModalHtml /deep/img {
  max-width: 100%;
}
.register {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  border: 1px solid rgb(183, 193, 194);
  color: rgb(70, 158, 209);
  width: 70%;
  padding: 10px 0;
  text-align: center;
  border-radius: 3px;
}
</style>
